exports = module.exports = require("../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".projectContainer-997c9{display:flex}.projectSelect-05d26{margin-right:10px}", ""]);

// Exports
exports.locals = {
	"projectContainer": "projectContainer-997c9",
	"projectSelect": "projectSelect-05d26"
};